<template>
    <div>
        <el-card class="allot_card">
            <div slot="header" class="clearfix">
                <span style="line-height: 36px;">设备广告列表</span>
                <el-button style="float: right;" type="danger" @click="deletleItem">删除</el-button>
            </div>
            <div>
                <el-table
                ref="itemSelect"
                v-loading="table_loading"
                element-loading-text="拼命加载中"
                :data="itemData"
                stripe
                border
                fit
                height="600"
                style="width: 100%"
                @selection-change="itemSelectionChange">
                    <el-table-column
                        type="selection"
                        width="40">
                    </el-table-column>
                    <el-table-column
                        prop="num"
                        header-align="center"
                        width="95"
                        label="广告编号">
                    </el-table-column>
                    <el-table-column
                        prop="resource"
                        header-align="center"
                        width="150"
                        label="资源预览">
                        <template scope="scope">
                            <a v-if="scope.row.type==='IMAGE'" style="barder: 1px solid #ddd" :href="scope.row.resource" target="_blank">
                                <img style="width:100%; max-width:180px; margin-top:10px;" v-bind:src="scope.row.resource" />
                            </a>
                             <a v-if="scope.row.type==='VIDEO'" style="barder: 1px solid #ddd" :href="scope.row.resource" target="_blank">
                                <video controls="controls" style="max-width:200px;margin-top: 6px;">
                                    <source :src="scope.row.resource">
                                    该浏览器不支持视频播放
                                </video>
                            </a>
                        </template>
                    </el-table-column>
                    </el-table-column>
                    <el-table-column
                        prop="name"
                        header-align="center"
                        min-width="95"
                        label="广告名称">
                    </el-table-column>
                    <el-table-column
                        prop="content"
                        header-align="center"
                        min-width="95"
                        label="广告描述">
                    </el-table-column>
                    <el-table-column
                        prop="type"
                        header-align="center"
                        min-width="85"
                        label="类型">
                    </el-table-column>
                    <el-table-column
                        prop="createPeople"
                        header-align="center"
                        min-width="85"
                        label="创建人">
                    </el-table-column>
                    <el-table-column
                        prop="onTime"
                        header-align="center"
                        min-width="120"
                        label="开播时间">
                    </el-table-column>
                    <el-table-column
                        prop="offTime"
                        header-align="center"
                        min-width="120"
                        label="停播时间">
                    </el-table-column>
                    <el-table-column
                        prop="longTime"
                        header-align="center"
                        width="65"
                        label="时长">
                    </el-table-column>
                    <el-table-column
                        prop="startTime"
                        header-align="center"
                        min-width="120"
                        label="播放时间">
                    </el-table-column>
                </el-table>
                <div class="table_pagination">
                    <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="pageNo"
                        :page-sizes="[5, 10, 15, 20]"
                        :page-size="pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="pageTotal">
                    </el-pagination>
                </div>
            </div>
        </el-card>
        <div class="seeAdMask" v-if="deleleShowBox">
            <div class="box">
                <h3>提示</h3>
                <div class="content">
                    <p>此操作将在设备上删除所选中的文件, 是否继续?</p>
                    <div>
                        <el-button @click="boxClose">取消</el-button>
                        <el-button @click="delItemCommit" type="primary">确认</el-button>
                    </div>
                </div>
                <span @click="boxClose"
                style="position: absolute; top: 0;right:0;padding:10px;color:#FF4949">
                    <i class="el-icon-close Danger"></i>
                </span>
            </div>
        </div>
    </div>
</template>

<script>
    import $axios from '../../https/config'
    export default {
      props: ['deviceCode', 'seeType'],
      data () {
        return {
          itemData: [],
          itemSelect: [],
          pageTotal: 0,
          pageSize: 10,
          pageNo: 1,
          table_loading: false,
          adResSelectList: [],
          deleleShowBox: false,
          delFinish: false
        }
      },
      created: function () {
        this.pageNo = 1
        this.queryItemDataList(this.pageNo, this.pageSize, this.deviceCode)
      },
      methods: {
        queryItemDataList (tPageNo, tPageSize, tDevieCode) {
          var _this = this
          var params = {
            pageNo: tPageNo,
            pageSize: tPageSize,
            deviceCode: tDevieCode
          }
          this.table_loading = true
          var url = '/device/getDeviceAd'
          if (this.seeType=="firstAd"){
            url = '/device/getDeviceFirstAd'
          }else if (this.seeType=="fuAd"){
            url = '/device/getDeviceFuAd'
          }
          $axios.get(url, params, 'headers', function (res) {
            _this.table_loading = false
            if (res && res.resultStatus === true) {
              var resData = []
              if (res.resultData && res.resultData.list.length > 0) {
                _this.pageTotal = res.resultData.count
                for (var i = 0; i < res.resultData.list.length; i++) {
                  var itemData = res.resultData.list[i]
                  var item = {
                    num: itemData.materialid,
                    resource: itemData.url,
                    name: itemData.title,
                    content: itemData.content,
                    createDate: itemData.create_time,
                    type: itemData.type,
                    createPeople: itemData.materialid,
                    onTime: itemData.ontime,
                    offTime: itemData.offtime,
                    longTime: itemData.duration + 's',
                    startTime: itemData.playdate,
                    id: itemData.id
                  }
                  resData.push(item)
                }
                _this.itemData = resData
              }
            } else {
            }
          }, function (err) {
            err
          })
        },
        handleSizeChange (val) {
          this.pageSize = val
          this.queryItemDataList(this.pageNo, this.pageSize, this.deviceCode)
        },
        handleCurrentChange (val) {
          this.pageNo = val
          this.queryItemDataList(this.pageNo, this.pageSize, this.deviceCode)
        },
        itemSelectionChange (val) {
          this.itemSelect = val
        },
        deletleItem () {
          if (this.itemSelect.length > 0) {
            this.deleleShowBox = true
          } else {
            this.$message({
              type: 'warning',
              duration: 1000 * 5,
              message: '请选择要删除的广告!'
            })
          }
        },
        delItemCommit () {
          for (var i = 0; i < this.itemSelect.length; i++) {
            if (this.itemSelect.length - 1 === i) {
              this.delFinish = true
            } else {
              this.delFinish = false
            }
            this.delSetAdResource(this.itemSelect[i].id, this.deviceCode)
          }
        },
        delSetAdResource (tItemSelect, tDeviceCode) {
          var _this = this
          var params = {
            adId: tItemSelect + '',
            deviceCode: tDeviceCode
          }
          var url = '/resource/delSetAdResource'
          if (this.seeType=="firstAd"){
            url = '/resource/delSetFirstAdResource'
          }else if (this.seeType == "fuAd"){
            url = '/resource/delSetFuAdResource'
          }

          $axios.get(url, params, 'headers', function (res) {
            if (res && res.resultStatus === true) {
              if (_this.delFinish) {
                _this.boxClose(true)
              }
              _this.$message({
                type: 'success',
                duration: 1000 * 5,
                message: '删除广告成功!'
              })
            } else {
              if (_this.delFinish) {
                _this.boxClose(true)
              }
              _this.$message({
                type: 'error',
                duration: 1000 * 5,
                message: '删除广告失败!'
              })
            }
          }, function (err) {
            err
          })
        },
        boxClose (tType) {
          this.deleleShowBox = false
          if (tType) {
            this.$emit('boxClose', tType)
          }
        }
      }
    }
</script>

<style lang="scss">
    .allot_card {
        margin: 10px;
        position: relative;
        overflow-y: auto;
        height: 85%;

        .el-card__header {
            padding: 10px;
        }
        .el-card__body {
            padding: 10px;
        }
    }
    .seeAdMask {
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        position: fixed;
        background: rgba(0, 0, 0, 0.3);
        z-index: 1001;

        .box {
            width: 400px;
            background: white;
            border-radius: 5px;
            box-shadow: 0 0 10px #666;
            top: 30%;
            left: 50%;
            margin-left: -200px;
            position: absolute;

            .el-button {
                width: 40%;
                margin: 4%;
            }
        }
    }
    .bindTable a>img{
      margin: 0;
      padding: 0;
      position: relative;
      height: auto;
    }
</style>



// WEBPACK FOOTER //
// src/page/deviceMgr/seeAd.vue